import {I18n} from "i18n-js";

export const i18n = new I18n({
    en: {
        myCircolo: "My Circolo",
        yachtClub: "Yacht club\nin the center\nof Bari",
        login: "Login (Username)",
        password: "Password",
        incorrectLoginPassword: "Incorrect login and/or password",
        incorrectLogin: "Incorrect login",
        signUp: "Sign up",
        yourName: "Your Name",
        yourLastName: "Your Last Name",
        yourEmail: "Your E-mail",
        createPassword: "Create a Password",
        enterName: "Please enter a name",
        enterLastName: "Please enter your last name",
        enterEmail: "Please enter e-mail",
        enterPassword: "Please enter a password",
        hiUser: "Hi {{user}}!",
        welcome: "Welcome to My Circolo.\nWe are glad that you are with us!",
        activity: "Activity",
        restaurant: "Restaurant",
        gymSauna: "Gym & Sauna",
        gymSaunaTitle: "Gym & Sauna",
        port: "Port",
        account: "Account",
        you: "You:",
        age: "Age:",
        mail: "Mail:",
        phone: "Phone:",
        address: "Address:",
        payMembership: "Pay membership fee",
        membershipFee: "Membership fee",
        noPaymentDebts: "No membership fees to pay",
        installmentsAvailable: "{{count}} due installment(s)",
        selectedTotal: "Selected total",
        proceedPayment: "Proceed to payment",
        paymentSuccess: "Payment completed successfully.",
        paymentCanceled: "Payment canceled.",
        paymentFail: "Payment failed. Please contact the secretariat if the charge was completed.",
        paymentPending: "Payment is being processed.",
        paymentAmountsChanged: "The amounts have changed. Review the updated fees and try again.",
        paymentStatusUnknown: "Unable to determine the payment status. Please try again.",
        dueDate: "Due date",
        dueDateUnavailable: "Not available",
        menu: "Menu",
        reservation: "Reservation",
        reservations: "Reservations",
        newReservation: "New reservation",
        numberPeople: "Number of people",
        dateReservation: "Date of reservation",
        timeReservation: "Time of reservation",
        inside: "Inside",
        outside: "Outside",
        zoneOutside: "Zone outside or inside the club",
        individualOrder: "Individual order",
        email: "E-mail",
        reservationRestaurant: "Reservation\nRestaurant",
        reservationSauna: "Reservation\nSauna",
        reservationGym: "Reservation\nGym",
        yourApplication: "Your application has been successfully sent to the manager.\nWe will contact you soon.",
        smthWrong: "Something went wrong.\nPlease try again.",
        error: "Error!",
        close: "Close",
        gym: "Gym",
        nowFull: "Now full {{percents}}%",
        sauna: "Sauna",
        reservationLeft: " reservation left", 
        outOf: "out of ",
        confirm: "Confirm",
        cancel: "Cancel",
        incorrectEmail: "Incorrect email address",
        socialMenu: "Social\nmenu",
        wineCard: "Wine\ncard",
        perPerson: "Per person",
        debt: "Debt:",
        payNow: "Pay now",
        duration: "Duration of session",
        duration30: "30 minutes",
        duration60: "1 hour",
        duration360: "3 hours",
        recoverPassword: "Remember password",
        recoverPasswordText: "Enter your login. A new password will be sent to your email.",
        recoverPasswordOkText: "A new password will be sent to your email",
        logOut: "Log out",
        yesLogOut: "Yes, log out",
        sureLogout: "Are sure you want to log out?",
        loginDoesNotExist: "The login you entered does not exist",
        yourReservations: "Your reservations",
        noReservations: "You have no reservations",
        noAvailableSlots: "No available slots for this date",
        search: "Search",
        availableSlots: "Available slots",
        book: "Book",
        availableSpots: "Available spots",
		noSlotsBooked: "No slots booked",
        confirmAction: "Are you sure you want to {{action}} this reservation?",
        delete: "Delete",
        slotSearchFail: "Unable to load slots.\nPlease try again later.",
        bookingSuccess: "Booking completed successfully.",
        bookingFail: "Booking failed. Please try again.",
        deleteSuccess: "Reservation successfully canceled.",
        deleteFail: "Failed to cancel reservation. Please try again.",
        participants: "Participants.",
        notes: "Notes.",
        notesPlaceholder: "Allergies, preferences, requests...",
        months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        daysShort: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],

        appName: "CIRCOLO DELLA VELA",
        installTitle: "Install App",
        installSubtitle: "For a better experience, add the app to your home screen.",
        
        iosTitle: "Instructions for iPhone",
        iosStep1: " Tap the Share button in the bottom bar.",
        iosStep2: " Scroll down and select 'Add to Home Screen'.",
        iosStep3: " Confirm by tapping 'Add'.",
        add: "Add to Home screen",

        androidTitle: "Instructions for Android",
        androidStep1: " Tap the menu icon (three dots) in the top right.",
        androidStep2: " Select 'Install app' or 'Add to Home screen'.",
        androidStep3: " Confirm the installation.",

        desktopTitle: "Available on Mobile",
        desktopStep: "This feature is designed for smartphones. Open this site on your phone to install the app.",
    },
    it: {
        myCircolo: "My Circolo",
        yachtClub: "Lo Yacht club\nnel centro\ndi Bari",
        login: "Login (Username)",
        password: "Password",
        incorrectLoginPassword: "Login e/o password errate",
        incorrectLogin: "Login errate",
        signUp: "Registrati",
        yourName: "Nome",
        yourLastName: "Cognome",
        yourEmail: "E-mail",
        createPassword: "Crea una Password",
        enterName: "Inserisci il tuo Nome",
        enterLastName: "Inserisci il tuo Cognome",
        enterEmail: "Inserisci la tua E-Mail",
        enterPassword: "Inserisci la tua Password",
        hiUser: "Ciao {{user}}!",
        welcome: "Benvenuti nell’App\nCircolo Vela Bari.\nSiamo lieti di averti con noi!",
        activity: "Attività",
        restaurant: "Ristorante",
        gymSauna: "Palestra e Sauna",
        gymSaunaTitle: "Palestra\ne Sauna",
        port: "Porto",
        account: "Account",
        you: "Tu",
        age: "Età",
        mail: "Mail",
        phone: "Telefono",
        address: "Indirizzo",
        payMembership: "Paga la quota associativa",
        membershipFee: "Quota associativa",
        noPaymentDebts: "Non ci sono quote da pagare",
        installmentsAvailable: "{{count}} quota/e scaduta/e",
        selectedTotal: "Totale selezionato",
        proceedPayment: "Procedi al pagamento",
        paymentSuccess: "Pagamento completato con successo.",
        paymentCanceled: "Pagamento annullato.",
        paymentFail: "Pagamento non completato. Contatta la segreteria se l'addebito e' stato eseguito.",
        paymentPending: "Pagamento in elaborazione.",
        paymentAmountsChanged: "Gli importi sono cambiati. Controlla le quote aggiornate e riprova.",
        paymentStatusUnknown: "Impossibile determinare lo stato del pagamento. Riprova.",
        dueDate: "Scadenza",
        dueDateUnavailable: "Non disponibile",
        menu: "Menu",
        reservation: "Prenotazione",
        reservations: "Prenotazioni",
        newReservation: "Nuova prenotazione",
        numberPeople: "Numero di persone",
        dateReservation: "Data prenotazione",
        timeReservation: "Orario prenotazione",
        inside: "All’interno",
        outside: "All’esterno",
        zoneOutside: "All’interno o all’esterno del circolo",
        individualOrder: "Ordine Individuale",
        email: "E-mail",
        reservationRestaurant: "Prenotazione\nper il Ristorante",
        reservationSauna: "Prenotazione\nper il Sauna",
        reservationGym: "Prenotazione\nper il Palestra",
        yourApplication: "La tua richiesta di prenotazione è stata inviata con successo.\nSarai presto contattato.",
        smthWrong: "Qualcosa è andato storto.\nPer favore riprova.",
        error: "Errore!",
        close: "Chiudi",
        gym: "Palestra",
        nowFull: "Adesso è piena al {{percents}}%",
        sauna: "Sauna",
        reservationLeft: " posti disponibili",
        outOf: "su ",
        confirm: "Confermare",
        cancel: "Annulla",
        incorrectEmail: "Indirizzo email errato",
        socialMenu: "Menu sociale",
        wineCard: "Carta del vini",
        perPerson: "A persona",
        debt: "Debito:",
        payNow: "Paga ora",
        duration: "Durata della sessione",
        duration30: "30 minuti",
        duration60: "1 ora",
        duration360: "3 ore",
        recoverPassword: "Recupero della password",
        recoverPasswordText: "Inserisci l'indirizzo login. Una nuova password verrà inviata alla tua email.",
        recoverPasswordOkText: "Una nuova password verrà inviata alla tua email",
        logOut: "Uscire dall'applicazione",
        yesLogOut: "Sì, esci",
        sureLogout: "Sei sicuro di voler uscire dall'app?",
        loginDoesNotExist: "Il login che hai inserito non esiste",
        yourReservations: "Le tue prenotazioni",
        noReservations: "Non hai prenotazioni",
        noAvailableSlots: "Nessuna prenotazione disponibile per questa data",
        search: "Cerca",
        availableSlots: "Orari disponibili",
        book: "Prenota",
        availableSpots: "Posti disponibili",
		noSlotsBooked: "Nessuna prenotazione effettuata",
        confirmAction: "Sei sicuro di voler {{action}} questa prenotazione?",
        delete: "Eliminare",
        slotSearchFail: "Impossibile caricare gli slot.\nRiprova più tardi.",
        bookingSuccess: "Prenotazione completata con successo.",
        bookingFail: "Prenotazione fallita. Riprova.",
        deleteSuccess: "Prenotazione cancellata con successo.",
        deleteFail: "Errore durante la cancellazione. Riprova.",
        participants: "Partecipanti.",
        notes: "Note.",
        notesPlaceholder: "Allergie, preferenze, richieste…",
        months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
        daysShort: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
        
        appName: "CIRCOLO DELLA VELA",
        installTitle: "Installa l'App",
        installSubtitle: "Per un'esperienza migliore, aggiungi l'app alla schermata home del tuo dispositivo.",
        
        iosTitle: "Istruzioni per iPhone",
        iosStep1: " Tocca il tasto 'Condividi' nella barra in basso.",
        iosStep2: " Scorri e seleziona 'Aggiungi alla schermata Home'.",
        iosStep3: " Conferma cliccando su 'Aggiungi'.",
        add: "Aggiungi alla schermata Home",

        androidTitle: "Istruzioni per Android",
        androidStep1: " Tocca l'icona del menu (tre puntini) in alto a destra.",
        androidStep2: " Seleziona 'Aggiungi a schermata Home'.",
        androidStep3: " Segui le istruzioni a schermo per confermare.",

        desktopTitle: "Disponibile su Mobile",
        desktopStep: "Questa funzionalità è pensata per smartphone. Apri questo sito dal tuo telefono per installare l'applicazione.",
        
    },
});
